import { PerspectiveCamera } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';
import { Grid } from 'ohzi-core';
import { Debug } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { Screen } from 'ohzi-core';
import { Graphics } from 'ohzi-core';
import { ResourceContainer } from 'ohzi-core';
import { Time } from 'ohzi-core';

import { Color } from 'three';
import { Scene } from 'three';
import { Mesh } from 'three';
import { Object3D } from 'three';
import { BoxGeometry } from 'three';
import { Shape } from 'three';
import { MeshPhongMaterial } from 'three';
import { ExtrudeGeometry } from 'three';
import { CubeRefractionMapping } from 'three';
import { WebGLRenderTarget } from 'three';
import { HalfFloatType } from 'three';
import { ShadowMaterial } from 'three';
import { PlaneGeometry } from 'three';

import GenericGlass from './GenericGlass';
import Tape from './Tape';
import Spacer from './Spacer';
import MeasurementArrows from './MeasurementArrows';

export default class Structure extends Object3D
{

  constructor() 
  {
    super();
   
    this.rt = new WebGLRenderTarget(
      Screen.width,
      Screen.height,
      {
        type: HalfFloatType
      }
    );
    this.glasses = [];

    this.measurementArrows = new MeasurementArrows();
    this.measurementArrows.position.x = 2;
    this.measurementArrows.position.y = -0.2;

    this.tapeInitial = new Tape();
    this.tapeFinal = new Tape();

    this.tapeInitial.position.z = - this.tapeInitial.width;

    this.add(this.tapeInitial);
    this.add(this.tapeFinal);

    this.frg = new GenericGlass(this.rt, true);
    this.middle_glass = new GenericGlass(this.rt);
    this.outside_glass = new GenericGlass(this.rt);

    this.spacer_middle_glass = new Spacer();
    this.spacer_outside_glass = new Spacer();

    this.add(this.frg);
    this.add(this.middle_glass);
    this.add(this.outside_glass);
    this.add(this.spacer_middle_glass);
    this.add(this.spacer_outside_glass);

    // SceneManager.textScene.add(this.measurementArrows);

    this.glasses.push(this.frg);
    this.glasses.push(this.middle_glass);
    this.glasses.push(this.outside_glass);

  }

  set(frg, mg, og, smg = {thickness:0}, sog = {thickness:0}, rotate_frg)
  {


    frg = frg?? {thickness:0, layers:[this.frg.thickness+':0']};
    mg = mg?? {thickness:0, layers:[this.middle_glass.thickness+':0']};
    og = og?? {thickness:0, layers:[this.outside_glass.thickness+':0']};


    let initial_structure = {
      frg : {thickness : this.frg.thickness, layers : [this.frg.thickness +':0']},
      middle_glass : {thickness : this.middle_glass.thickness, layers : [this.middle_glass.thickness +':0']},
      outside_glass : {thickness : this.outside_glass.thickness, layers : [this.outside_glass.thickness +':0']},
      spacer_middle_glass : this.spacer_middle_glass,
      spacer_outside_glass : this.spacer_outside_glass,
    };

    let target_structure = {
      frg : {thickness : frg.thickness, layers : frg.layers},
      middle_glass : {thickness : mg.thickness, layers : mg.layers},
      outside_glass : {thickness : og.thickness, layers : og.layers},
      spacer_middle_glass : {thickness : smg.thickness},
      spacer_outside_glass : {thickness : sog.thickness}
    };

    if (rotate_frg)
    {
      target_structure.frg.layers = target_structure.frg.layers.slice().reverse();
    }
    
    this.__lerp_structure(initial_structure, target_structure, 1000, console.log); 
  }

  __lerp_structure(str1, str2, time, callback) 
  {
    // this function can be called several times
    // if that's the case, the animation should resets
    // and the events should be clear

    if (this.___interrupt) this.___interrupt();

    this.___interrupt = () => 
    {
      this.____set(str1.frg, str1.middle_glass, str1.outside_glass, str1.spacer_middle_glass, str1.spacer_outside_glass); 
      window.clearInterval(this.___interval);
    };

    let interval_ms = 8;
    let lerper = 0;

    // we need to make 1 step in time mili seconds
    // but we do steps every $interval_ms ms interval, so each step size 
    let step_size = (1.0 / time) * interval_ms;

    this.___timeout = (()=>
    {
      this.____set(str2.frg, str2.middle_glass, str2.outside_glass, str2.spacer_middle_glass, str2.spacer_outside_glass); 
      this.___interrupt = undefined;
      window.clearInterval(this.___interval);
      callback();

    }).bind(this);

    this.___interval = setInterval((()=>
    {


      if(lerper > 1.0) 
      {
        this.___timeout();
        return;
      }

      let _lerper = Math.pow(lerper, 2);

      let lerp_structure = {
        'frg' : {'thickness' : str1.frg.thickness * (1-_lerper) + str2.frg.thickness * _lerper, 'layers' : str2.frg.layers},
        'middle_glass' : {'thickness' : str1.middle_glass.thickness * (1-_lerper) + str2.middle_glass.thickness * _lerper, 'layers' : str2.middle_glass.layers},
        'outside_glass' : {'thickness' : str1.outside_glass.thickness * (1-_lerper) + str2.outside_glass.thickness * _lerper, 'layers' : str2.outside_glass.layers},
        'spacer_middle_glass' : {'thickness' : str1.spacer_middle_glass.thickness * (1-_lerper) + str2.spacer_middle_glass.thickness * _lerper},
        'spacer_outside_glass' : {'thickness' : str1.spacer_outside_glass.thickness * (1-_lerper) + str2.spacer_outside_glass.thickness * _lerper}
      };

      this.____set(lerp_structure.frg, lerp_structure.middle_glass, lerp_structure.outside_glass, lerp_structure.spacer_middle_glass, lerp_structure.spacer_outside_glass); 

      lerper += step_size;

    }).bind(this), interval_ms);


  }

  ____set(frg, mg, og, smg, sog) 
  {

    if (frg.thickness === undefined) 
    {
      console.warn('TODO : get a better data handling');return;
    }
    const bias = 0.0005;
    let space = bias;
    // INITIAL TAPE ALWAYS AT 0
    // FRG

    this.frg.set(frg.thickness, frg.layers);
    this.frg.shiftZ = space;
    space += this.frg.width + bias;
    // FINAL TAPE

    this.tapeFinal.set_short(sog.thickness > 0.0005);
    this.tapeFinal.shiftZ = space + 0.005;
    space += this.tapeFinal.width + bias;

    // SPACER 1
    this.spacer_middle_glass.set(smg.thickness);
    this.spacer_middle_glass.shiftZ = space;
    space += this.spacer_middle_glass.width + bias;
    // MIDDLE GLASS
    
    this.middle_glass.set(mg.thickness, mg.layers);
    this.middle_glass.shiftZ = space;
    space += this.middle_glass.width + bias;
    // SPACER 2
    
    this.spacer_outside_glass.set(sog.thickness);
    this.spacer_outside_glass.shiftZ = space;
    space += this.spacer_outside_glass.width + bias;
    // OUTSIDE GLASS
    
    this.outside_glass.set(og.thickness, og.layers);
    this.outside_glass.shiftZ = space;
    space += this.outside_glass.width + bias;

    this.measurementArrows.set( space, sog.thickness + og.thickness + mg.thickness + smg.thickness + frg.thickness );
  }

  init()
  {

  }

  start()
  {

  }

  update()
  {
    Graphics.render(SceneManager.backScene, CameraManager.current, this.rt);
    Graphics._renderer.clear(true, true);

    for (let i = 0; i < this.glasses.length; i++) 
    {
      this.glasses[i].update();
    }

    this.tapeInitial.update();
    this.tapeFinal.update();

  }


}


